import * as React from "react";
import { forwardRef } from "react";
const SvgFiberplaneLogoOrange = (props, ref) => /* @__PURE__ */ React.createElement("svg", { width: "100%", height: "100%", viewBox: "0 0 22 22", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", xmlSpace: "preserve", "xmlns:serif": "http://www.serif.com/", style: {
  fillRule: "evenodd",
  clipRule: "evenodd"
}, ref, ...props }, /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,-23.2192,-19.2192)" }, /* @__PURE__ */ React.createElement("path", { d: "M34,40C38.382,40 40.818,40 42.409,38.409C44,36.818 44,34.382 44,30C44,25.618 44,23.182 42.409,21.591C40.818,20 38.382,20 34,20C29.618,20 27.182,20 25.591,21.591C24,23.182 24,25.618 24,30C24,34.382 24,36.818 25.591,38.409C27.182,40 29.618,40 34,40Z", style: {
  fill: "rgb(255,87,51)",
  fillRule: "nonzero"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,-23.2192,-19.2192)" }, /* @__PURE__ */ React.createElement("path", { d: "M42.232,38.232C41.488,38.976 40.54,39.359 39.215,39.554C37.881,39.749 36.198,39.75 34,39.75C31.802,39.75 30.119,39.749 28.785,39.554C27.46,39.359 26.512,38.976 25.768,38.232C25.024,37.488 24.641,36.54 24.446,35.215C24.251,33.881 24.25,32.198 24.25,30C24.25,27.802 24.251,26.119 24.446,24.785C24.641,23.46 25.024,22.512 25.768,21.768C26.512,21.024 27.46,20.641 28.785,20.446C30.119,20.251 31.802,20.25 34,20.25C36.198,20.25 37.881,20.251 39.215,20.446C40.54,20.641 41.488,21.024 42.232,21.768C42.976,22.512 43.359,23.46 43.554,24.785C43.749,26.119 43.75,27.802 43.75,30C43.75,32.198 43.749,33.881 43.554,35.215C43.359,36.54 42.976,37.488 42.232,38.232Z", style: {
  fill: "none",
  fillRule: "nonzero",
  stroke: "rgb(171,20,0)",
  strokeOpacity: 0.2,
  strokeWidth: "0.5px"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,-23.2192,-19.2192)" }, /* @__PURE__ */ React.createElement("path", { d: "M28.255,29.127L28.255,30.761L34.565,30.774L34.937,29.14L28.255,29.127Z", style: {
  fill: "white",
  fillRule: "nonzero",
  stroke: "rgb(171,20,0)",
  strokeOpacity: 0.5,
  strokeWidth: "0.3px"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,-23.2192,-19.2192)" }, /* @__PURE__ */ React.createElement("path", { d: "M28.255,25.853L28.255,27.487L35.31,27.5L35.373,27.214C35.531,26.527 35.026,25.866 34.338,25.866L28.255,25.853Z", style: {
  fill: "white",
  fillRule: "nonzero"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,-23.2192,-19.2192)" }, /* @__PURE__ */ React.createElement("path", { d: "M28.255,25.853L28.255,27.487L35.31,27.5L35.373,27.214C35.531,26.527 35.026,25.866 34.338,25.866L28.255,25.853Z", style: {
  fill: "none",
  fillRule: "nonzero",
  stroke: "rgb(188,22,0)",
  strokeOpacity: 0.5,
  strokeWidth: "0.3px"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,-23.2192,-19.2192)" }, /* @__PURE__ */ React.createElement("path", { d: "M34.185,32.408L34.557,30.774L38.551,30.78L37.964,32.414L34.185,32.408Z", style: {
  fill: "white",
  fillRule: "nonzero",
  stroke: "rgb(171,20,0)",
  strokeOpacity: 0.5,
  strokeWidth: "0.3px"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,-23.2192,-19.2192)" }, /* @__PURE__ */ React.createElement("path", { d: "M34.932,29.14L35.311,27.506L41.003,27.486L40.334,29.114L34.932,29.14Z", style: {
  fill: "white",
  fillRule: "nonzero",
  stroke: "rgb(171,20,0)",
  strokeOpacity: 0.5,
  strokeWidth: "0.3px"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,-23.2192,-19.2192)" }, /* @__PURE__ */ React.createElement("path", { d: "M28.255,32.394L28.255,34.028L33.814,34.041L34.187,32.407L28.255,32.394Z", style: {
  fill: "white",
  fillRule: "nonzero",
  stroke: "rgb(171,20,0)",
  strokeOpacity: 0.5,
  strokeWidth: "0.3px"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,-23.2192,-19.2192)" }, /* @__PURE__ */ React.createElement("path", { d: "M36.184,35.681L35.03,35.681C34.197,35.681 33.591,34.864 33.805,34.041L36.822,34.041L36.184,35.681Z", style: {
  fill: "white",
  fillRule: "nonzero",
  stroke: "rgb(171,20,0)",
  strokeOpacity: 0.5,
  strokeWidth: "0.3px"
} })));
const ForwardRef = forwardRef(SvgFiberplaneLogoOrange);
export default ForwardRef;
